<template>
    <footer class="footer" :class="isLight ? 'is-light': ''">
        <div class="footer__copy" >
            <div class="footer__copy-desc">
                Copyright - ACISO CONSULTING GmbH
            </div>
            <div class="footer__copy-mob">
                Copyright <br> - ACISO CONSULTING GmbH
            </div>
        </div>
        <div class="footer__auth" v-if="isMember">
            <router-link class="footer__link" :to="{ name: 'imprint' }">{{$t('form.imprint')}}</router-link>
            <router-link class="footer__link" :to="{ name: 'privacy' }">{{$t('form.privacy')}}</router-link>
            <router-link class="footer__link" :to="{ name: 'terms-of-use' }">{{$t('form.term_link')}}</router-link>
        </div>
    </footer>
</template>

<script>
    export default {
        props: {
            isLight: {
                type: Boolean,
                default: false
            },
            isMember: {
                type: Boolean,
                default: false
            }
        }
    }
</script>

<style lang="sass" scoped>
    .footer
        &__copy
            &-desc
                display: none
                +rmin(600)
                    display: block
            &-mob
                display: none
                +r(599)
                    display: block
</style>